var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion",class:{ open: _vm.open },style:({
    '--icon-mask': `url(${_vm.open && _vm.iconMaskOpen ? _vm.iconMaskOpen : _vm.iconMask})`,
    '--icon-color': _vm.iconColor,
    '--icon-width': _vm.iconWidth,
    '--icon-height': _vm.iconHeight,
  })},[_c('div',{staticClass:"header-part d-flex justify-content-between align-items-center",on:{"click":_vm.toggleContent}},[_c('div',{staticClass:"title"},[_vm._t("header")],2),_c('div',{staticClass:"toggle-icon"},[_c('span',{staticClass:"toggle-arrow",class:[{ open: _vm.open && _vm.rotateIconOnOpen }, _vm.iconClass]})])]),(_vm.contentIsOpened)?_c('div',{ref:"content-part",staticClass:"content-part"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }